import { render, staticRenderFns } from "./ServersShortlist.vue?vue&type=template&id=29b4fe5c&"
import script from "./ServersShortlist.vue?vue&type=script&lang=js&"
export * from "./ServersShortlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports